import React, { Suspense } from 'react'
import { BaseWidget, Mosaic } from '@eduact/ed-components'
import { useAppSelector } from '@Hooks/ReduxHooks'
import { useStudentScreenSize } from '@eduact/student-theme'
import styled from 'styled-components'
import { rgba } from 'polished'
import loadable from '@loadable/component'
// import CalenderWidget from './Components/CalenderWidget'
import LeadershipBoardWidget from './Components/LeadershipBoardWidget'
import LearningTimeWidget from './Components/LearningTimeWidget'
import CalenderWidget from './Components/CalenderWidget'
import KpiStrip from './Components/KpiStrip/KpiStrip'
import { useTranslation } from 'react-i18next'
const WalletHistoryWidget = loadable(() => import('./Components/WalletHistoryWidget'))
const CompletedUnitsWidget = loadable(() => import('./Components/CompletedUnitsWidget'))
const MyClassroomsWidget = loadable(() => import('./Components/MyClassroomsWidget'))
const Overview = () => {
	const [t] = useTranslation('studentDashboard')
	const { user } = useAppSelector(state => state.auth)
	const { isDesktop, isMobile } = useStudentScreenSize()

	const hour = new Date().getHours()
	const timeGlyph = hour < 5 ? '🌙' : hour < 12 ? '🌅' : hour < 18 ? '☀️' : '🌙'

	return (
		<OverviewContainer>
			<Suspense fallback={<div>{t('loading')}</div>}>
				<Mosaic width={'100%'} gridGap={{ sm: '0.625rem', lg: '1.563rem' }}>
					<Mosaic.Col width={'100%'} minWidth={0} flex={{ lg: 2 }}>
						<Mosaic.Row width={'100%'} alignItems={'stretch'}>
							<Mosaic.Col flex={{ md: 1.5 }}>
								<WelcomeBanner>
									<div className="copy">
										<div className="greeting">
											{user?.first_name ? t('welcome_name', { name: user.first_name }) : t('welcome')}
										</div>
										<div className="sub">{t('welcomeSub')}</div>
									</div>
									<span className="glyph" aria-hidden>
										{timeGlyph}
									</span>
								</WelcomeBanner>
							</Mosaic.Col>
							{!isMobile && (
								<Mosaic.Col flex={{ md: 1 }}>
									<BaseWidget widget={LeadershipBoardWidget} widgetProps={{}} />
								</Mosaic.Col>
							)}
						</Mosaic.Row>
						<Mosaic.Row width={'100%'}>
							<KpiStrip />
						</Mosaic.Row>
						<Mosaic.Row width={'100%'}>
							<Mosaic.Col flex={{ lg: 1 }} height="100%">
								<BaseWidget widget={LearningTimeWidget} widgetProps={{}} />
							</Mosaic.Col>

							<Mosaic.Col height={{ lg: '100%', md: '17.988rem', sm: '8.869rem' }} flex={{ sm: undefined, md: 2 }}>
								<CompletedUnitsWidget />
							</Mosaic.Col>
						</Mosaic.Row>
						<Mosaic.Row>
							<MyClassroomsWidget />
						</Mosaic.Row>
					</Mosaic.Col>
					<Mosaic.Col flex={{ lg: 1 }} minWidth={0}>
						{!isMobile && (
							<Mosaic.Row>
								<BaseWidget overflow={'unset'} contained withShadow widget={CalenderWidget} widgetProps={{}} />
							</Mosaic.Row>
						)}
						<Mosaic.Row flex={undefined}>
							<WalletHistoryWidget />
						</Mosaic.Row>
					</Mosaic.Col>
				</Mosaic>
			</Suspense>
		</OverviewContainer>
	)
}

export default Overview

const WelcomeBanner = styled.div`
	position: relative;
	overflow: hidden;
	background: var(--gradient-course-header);
	color: #fff;
	border-radius: var(--r-xl);
	box-shadow: var(--sh-rest);
	padding: 24px;
	width: 100%;
	height: 100%;
	min-height: 13.6rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
	.greeting {
		font: var(--fw-bold) 24px var(--font-sans);
		line-height: 1.2;
	}
	.sub {
		margin-top: 8px;
		font-size: 14px;
		color: rgba(255, 255, 255, 0.8);
		max-width: 28ch;
	}
	.glyph {
		position: absolute;
		inset-inline-end: 20px;
		top: 18px;
		font-size: 40px;
		opacity: 0.9;
	}
`

const OverviewContainer = styled.div`
	background: ${rgba('#FFF', 0.5)};
	width: 100%;
	padding: 11px;
	border-radius: 15px;
	${({ theme }) => `${theme.mediaQueries.large}{
		background : none;
		padding: 0;
	}`}
`
